<div class="min-h-screen bg-bg-base text-text-primary overflow-x-hidden">
<div class="max-w-7xl mx-auto w-full px-3 sm:px-6 lg:px-8 py-4 sm:py-8 lg:py-10 antialiased selection:bg-primary/20 selection:text-primary">
  @if (isLoading) {
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-8 lg:gap-10 animate-pulse">

    <div class="lg:col-span-2 min-w-0 space-y-4 sm:space-y-8">

      <div class="surface-card overflow-hidden">
        <div class="aspect-[16/9] bg-bg-secondary"></div>
        <div class="p-4 flex gap-3 overflow-hidden">
          @for (item of [1,2,3,4,5]; track item) {
          <div class="w-20 h-16 bg-bg-secondary rounded-xl shrink-0"></div>
          }
        </div>
      </div>

      <div class="surface-card p-4 sm:p-8 space-y-5">
        <div class="h-8 bg-bg-secondary rounded-xl w-3/4"></div>
        <div class="h-5 bg-bg-secondary rounded-lg w-1/2"></div>

        <div class="flex flex-wrap gap-4 pt-2">
          @for (item of [1,2,3,4]; track item) {
          <div class="flex items-center gap-2 bg-surface px-3 py-2 rounded-xl border border-border-subtle">
            <div class="w-5 h-5 bg-bg-secondary rounded-md"></div>
            <div class="h-4 bg-bg-secondary rounded-md w-12"></div>
          </div>
          }
        </div>

        <div class="space-y-2.5 pt-2 border-t border-border-subtle">
          <div class="h-4 bg-bg-secondary rounded-md w-full"></div>
          <div class="h-4 bg-bg-secondary rounded-md w-11/12"></div>
          <div class="h-4 bg-bg-secondary rounded-md w-4/5"></div>
        </div>

        <div class="space-y-3 pt-4">
          <div class="h-5 bg-bg-secondary rounded-md w-32"></div>
          <div class="flex flex-wrap gap-2">
            @for (item of [1,2,3,4,5,6]; track item) {
            <div class="h-8 bg-bg-secondary rounded-2xl w-24 border border-border-subtle"></div>
            }
          </div>
        </div>
      </div>

      <div class="surface-card p-4 sm:p-8">
        <div class="h-6 bg-bg-secondary rounded-md w-40 mb-5"></div>
        <div class="space-y-3">
          @for (item of [1,2,3]; track item) {
          <div class="border border-border-subtle rounded-2xl p-4 flex justify-between items-center bg-surface">
            <div class="space-y-2">
              <div class="h-5 bg-bg-secondary rounded-md w-28"></div>
              <div class="h-3 bg-bg-secondary rounded-md w-20"></div>
            </div>
            <div class="h-7 bg-bg-secondary rounded-lg w-24"></div>
          </div>
          }
        </div>
      </div>

      <div class="surface-card p-4 sm:p-8 overflow-hidden">
        <div class="h-6 bg-bg-secondary rounded-md w-48 mb-6"></div>
        <div class="grid grid-cols-7 gap-2">
          @for (item of
          [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35]; track item)
          {
          <div class="aspect-square bg-bg-secondary rounded-xl border border-border-subtle"></div>
          }
        </div>
      </div>
    </div>

    <div class="lg:col-span-1 min-w-0">
      <div class="surface-card p-6 space-y-5">
        <div class="text-center space-y-3 pb-4 border-b border-border-subtle">
          <div class="h-8 bg-bg-secondary rounded-xl w-36 mx-auto"></div>
          <div class="h-4 bg-bg-secondary rounded-md w-24 mx-auto"></div>
        </div>
        <div class="space-y-3">
          <div class="h-12 bg-surface border border-border-subtle rounded-2xl"></div>
          <div class="h-12 bg-surface border border-border-subtle rounded-2xl"></div>
          <div class="h-12 bg-surface border border-border-subtle rounded-2xl"></div>
          <div class="h-12 bg-bg-secondary rounded-2xl"></div>
        </div>
        <div class="pt-4 flex items-center gap-3 border-t border-border-subtle">
          <div class="w-12 h-12 bg-bg-secondary rounded-full"></div>
          <div class="space-y-1.5">
            <div class="h-4 bg-bg-secondary rounded-md w-28"></div>
            <div class="h-3 bg-bg-secondary rounded-md w-16"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  @else {
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-8 lg:gap-10">

    <div class="lg:col-span-2 min-w-0 space-y-4 sm:space-y-8">

      <div class="surface-card overflow-hidden transition-all duration-300">
        <app-unit-gallery [images]="galleryImages" [videos]="galleryVideos" [title]="displayTitle"
          [currentIndex]="currentImageIndex" (imageClick)="openImageModal()" (indexChange)="currentImageIndex = $event"
          [unitId]="unitData?._id" [isFavorite]="unitData?.isFavorite ?? false"
          [verified]="isVerified" [managed]="isManaged" />
      </div>

      <div class="surface-card p-0 sm:p-0 overflow-hidden">
        <app-unit-info [title]="displayTitle || 'Luxury Furnished Apartment - Fifth Settlement'"
          [location]="displayLocation || 'Fifth Settlement, New Cairo'" [bedrooms]="bedrooms ?? 3"
          [bathrooms]="bathrooms ?? 2" [area]="(area | roundToTenth) || '180 sqm'" [rating]="rating ?? 4.8" [reviews]="reviews ?? 24"
          [floor]="floor ?? 5" [furnished]="furnished !== null ? furnished : true" [yearBuilt]="yearBuilt"
          [unitType]="unitType" [unitNumber]="unitNumber" [adults]="adults" [children]="children"
          [description]="descriptionText || 'Luxury apartment in a prime location with all amenities and services. Super luxury finishing, wonderful view, close to all services and transportation.'"
          [amenities]="amenities.length ? amenities : ['Central AC', 'Fully Equipped Kitchen', 'Swimming Pool', 'Gym', '24/7 Security', 'Parking', 'Private Garden', 'Spacious Balcony']" />
      </div>

      <!-- @if (effectivePricing) {
      <div class="surface-card p-6 sm:p-8">
        <app-pricing-table [finalPricing]="effectivePricing!" [currency]="pricingCurrency"
          (priceSelected)="onPriceSelected($event)" />
      </div>
      } -->

      <div class="surface-card overflow-hidden">
        <app-availability-calendar [unitId]="unitData?._id" [availabilityPeriods]="unitAvailabilityPeriods"
          [seasonalPricing]="unitData?.seasonalPricing"
          [basePrice]="unitData?.basePricing?.price || unitData?.listingPrice?.rentPrice || unitData?.listingPrice?.salePrice || 0"
          [currency]="pricingCurrency" (dateRangeSelected)="onDateRangeSelected($event)"></app-availability-calendar>
      </div>

      <app-day-details-modal [show]="showDayDetails" [selectedDay]="selectedDay" (close)="closeDayDetails()"
        (bookDate)="openBookingPopup()" />

      <div class="surface-card overflow-hidden">
        <app-ai-analysis [aiAnalysis]="unitData?.aiAnalysis" />
      </div>

      @if (unitData?.salePricing?.plans?.length) { <div class="surface-card p-4 sm:p-8 rtl overflow-hidden">
        <div class="flex items-center gap-3 border-b border-border-subtle pb-4 mb-5">
          <div class="w-9 h-9 rounded-xl bg-primary/10 text-primary flex items-center justify-center border border-primary/20 shadow-sm">
            <i class="fa-solid fa-credit-card text-xs"></i>
          </div>
          <h2 class="h4">
            {{ 'unitDetails.payment.title' | translate }}
          </h2>
        </div>

        <div class="grid gap-3 sm:gap-4 sm:grid-cols-2">
          @for (plan of unitData!.salePricing!.plans!; track plan._id) {
          <div class="group min-w-0 border border-border hover:border-primary rounded-2xl p-4 sm:p-5 bg-bg-secondary hover:shadow-lg hover:shadow-primary/5 transition-all duration-300 flex flex-col justify-between">
            <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-4">
              <h3 class="body font-extrabold text-text-primary tracking-tight transition-colors break-words">
                {{ plan.name_ar || plan.name_en }}
              </h3>

              <span
                class="inline-flex items-center px-2.5 py-0.5 text-[10px] font-bold uppercase rounded-md tracking-wide"
                [class]="plan.saleType === 'cash' ? 'bg-success/10 text-success border border-success/20' : 'bg-info/10 text-info border border-info/20'">
                {{ plan.saleType === 'cash' ? ('unitDetails.payment.cash' | translate) :
                ('unitDetails.payment.installment' | translate) }}
              </span>
            </div>

            @if (plan.saleType === 'installment') {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3.5 text-[11px] font-bold text-text-secondary border-t border-border-subtle pt-3">
              @if (plan.downPaymentPercent) {
              <div class="flex items-center gap-2">
                <i class="fa-solid fa-percent text-text-muted text-xs w-4"></i>
                <span>{{ 'unitDetails.payment.downPayment' | translate }} <strong class="text-text-primary font-mono">{{
                    plan.downPaymentPercent | roundToTenth
                    }}%</strong></span>
              </div>
              }
              @if (plan.years) {
              <div class="flex items-center gap-2">
                <i class="fa-solid fa-calendar text-text-muted text-xs w-4"></i>
                <span>{{ 'unitDetails.payment.duration' | translate }} <strong class="text-text-primary font-mono">{{
                    plan.years }} {{ 'unitDetails.payment.years' | translate }}</strong></span>
              </div>
              }
              @if (plan.interestRate) {
              <div class="flex items-center gap-2">
                <i class="fa-solid fa-chart-line text-text-muted text-xs w-4"></i>
                <span>{{ 'unitDetails.payment.interestRate' | translate }} <strong class="text-text-primary font-mono">{{
                    plan.interestRate * 100 | roundToTenth
                    }}%</strong></span>
              </div>
              }
              @if (plan.discountPercent) {
              <div class="flex items-center gap-2 bg-success/10 px-1.5 py-0.5 rounded border border-success/20 w-fit">
                <i class="fa-solid fa-tag text-success text-xs"></i>
                <span class="text-success">{{ 'unitDetails.payment.discount' | translate }} <strong
                    class="font-mono">{{ plan.discountPercent | roundToTenth
                    }}%</strong></span>
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
      </div>
      }

      <div class="surface-card overflow-hidden">
        <app-location-map [nearbyLandmarks]="nearbyPlaces" [coordinates]="locationCoordinates"
          [locationAddress]="locationAddress" [locationArea]="locationArea" [locationCity]="locationCity"
          [locationCountry]="locationCountry" [latitude]="locationLat || 30.0444" [longitude]="locationLng || 31.2357"
          [propertyName]="displayTitle" [propertyImage]="heroImage" />
      </div>
    </div>

    <div class="lg:col-span-1 min-w-0">
      <div class="lg:sticky lg:top-32">
        <app-booking-sidebar [priceDisplay]="priceDisplay || '12 EGP'" [pricePeriod]="pricePeriodLabel || 'Monthly'"
          [pricePerMeter]="pricePerMeter" [securityDeposit]="securityDeposit" [commission]="commission"
          [cancellationPolicy]="cancellationPolicyLabel"
          [owner]="ownerInfo" [safetyTips]="safetyTips.length ? safetyTips : defaultSafetyTips"
          [hasSelectedDates]="!!selectedDateRange" (bookNow)="openBookingPopup()" />
      </div>
    </div>

  </div>
  }
</div>

<app-image-modal [show]="showImageModal" [images]="galleryImages" [currentIndex]="currentImageIndex"
  (close)="closeImageModal()" (indexChange)="currentImageIndex = $event" />

@if (showBookingPopup) {
<div class="fixed inset-0 bg-bg-base/80 backdrop-blur-md z-50 flex items-center justify-center p-3 sm:p-4 animate-fadeIn overflow-y-auto"
  (click)="closeBookingPopup()">
  <div (click)="$event.stopPropagation()" class="w-full max-w-3xl max-h-[calc(100vh-1.5rem)] sm:max-h-[calc(100vh-2rem)] overflow-y-auto transform transition-transform duration-300 scale-100">
    <app-book-the-apartment [unitId]="unitData?._id || null" [selectedStartDate]="selectedDateRange?.startDate"
      [selectedEndDate]="selectedDateRange?.endDate" [defaultGuests]="unitData?.maxGuests || 1"
      [defaultRentalType]="bookingRentalType" [defaultCurrency]="pricingCurrency" [defaultCity]="locationCity"
      [defaultState]="locationCity" [defaultCountry]="locationCountry" (closePopup)="closeBookingPopup()" />
  </div>
</div>
}
</div>


